import type { Infer } from 'superstruct';
import { enums } from 'superstruct';

export const ExportTypeDto = enums(['xlsx', 'csv'] as const);

export type ExportTypeDto = Infer<typeof ExportTypeDto>;
